import { createTheme } from '@mui/material';

const theme = createTheme({
    // typography: {
    //     fontFamily: ['Space Grotesk', 'sans-serif'].join(','),
    // },
});

export default theme;
